import rq from '@/request'

const resource = 'company-organizations'
const getBranches = params => rq.get(`${resource}/branches`, {params})
const getDistricts = params => rq.get(`${resource}/districts`, {params})
const getTeams = params => rq.get(`${resource}/teams`, {params})

export default {
  getBranches,
  getDistricts,
  getTeams
}



// WEBPACK FOOTER //
// ./src/api/company-organizations.js